<template>
  <button
    :class="
      compact
        ? [
            'row-container flex items-center gap-2 px-3 py-2',
            `own-menu-row--${color}`,
          ]
        : ['own-menu-row', `own-menu-row--${color}`]
    "
    @click="$emit('click', $event)"
  >
    <component
      :is="actionItem.icon"
      v-if="actionItem.icon"
      :class="!compact && 'own-menu-row__icon'"
      :size="16"
      weight="bold"
    />
    <span class="text-title-regular" v-text="actionItem.label"></span>
  </button>
</template>

<script>
const ALLOWED_COLORS = ['danger']

export default {
  name: 'OwnMenuRow',
  props: {
    /**
     * Single action item
     */
    actionItem: { type: Object, required: true },

    /**
     * Display compact spacing of menu row
     */
    compact: { type: Boolean, default: false },
  },
  emits: ['click'],
  computed: {
    color() {
      const { actionItem } = this

      if (actionItem.color && ALLOWED_COLORS.includes(actionItem.color)) {
        return actionItem.color
      } else {
        return 'default'
      }
    },
  },
}
</script>

<style lang="scss">
@use '@/styles/globals';

.row-container {
  cursor: default;
  border-radius: 8px;

  &:hover {
    background-color: var(--background-highlight);
  }
}

.own-menu-row {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 8px;
  text-align: left;
  cursor: default;
  width: 100%;

  &__icon {
    font-size: 16px;
    margin-right: 8px;
  }

  &:hover {
    background-color: var(--background-highlight);
  }

  &--default {
    color: var(--text-color-secondary);
  }

  &--danger {
    color: var(--status-danger);
  }
}
</style>
